import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function menuService() {
  const api = () => useApi()

  function getMenu(id) {
    return api().query(`${URLS.assessment}${id}/sidebar/`)
  }

  return {
    getMenu,
  }
}
